export default function StudioAuthoringProgramsController() {}
